import { omit } from "lodash";
import { safeDELETE, safeGET, safePOST } from "./SafeClient";
import {
    NegotiationStrategy,
    POCReport,
    ReportFeedback,
    FeedbackCreationRequest,
} from "../../types/ReportTypes";
import { splitHtmlByH2 } from "../Html";

export async function getReport(orderFormId: number, abort?: any): Promise<POCReport> {
    const report = await safeGET<POCReport>(`/api/report/${orderFormId}`, abort);
    if (report) {
        report.contractSummaryV1 = splitHtmlByH2(report.contractSummary ?? "");
        report.negotiationStrategyV1 = splitHtmlByH2(report.negotiationStrategy ?? "");
        report.topLegalPrioritiesV1 = splitHtmlByH2(report.topLegalPriorities ?? "");
    }
    return report;
}

export async function upsertReport(report: POCReport, abort?: any) {
    const reportToSave = omit(report, [
        "contractSummaryV1",
        "negotiationStrategyV1",
        "topLegalPrioritiesV1",
    ]);
    return safePOST(`/api/report/${report.orderFormId}`, reportToSave, abort);
}

export async function getStrategies(
    orderFormId: number,
    abort?: any
): Promise<NegotiationStrategy[]> {
    return safeGET(`/api/report/${orderFormId}/strategy`, abort);
}

export async function upsertStrategy(strategy: NegotiationStrategy, abort?: any) {
    return safePOST(`/api/report/${strategy.orderFormId}/strategy`, strategy, abort);
}

export function getReportFeedback(reportId: number, abort?: any): Promise<ReportFeedback[]> {
    return safeGET(`/api/report/${reportId}/feedback`, abort);
}

export function createReportFeedback(
    feedback: FeedbackCreationRequest,
    abort?: any
): Promise<ReportFeedback[]> {
    return safePOST(`/api/report/${feedback.reportId}/feedback`, feedback, abort);
}

export function deleteReportFeedback(
    reportId: number,
    feedbackId: number,
    abort?: any
): Promise<ReportFeedback> {
    return safeDELETE(`/api/report/${reportId}/feedback/${feedbackId}`, abort);
}

export function convertGoogleDoc(fileIdOrUrl: string, abort?: any) {
    return safePOST(`/api/report/convert/googledoctohtml`, { fileIdOrUrl }, abort);
}

export function convertGoogleSheet(fileIdOrUrl: string, abort?: any) {
    return safePOST(`/api/report/convert/googlesheettojson`, { fileIdOrUrl }, abort);
}
